<style lang="scss" scoped>
.filter-loading {
    @apply flex mb-16;
    &:before,
    &:after {
        content: "";
        height: 16px;
        @apply block rounded-sm bg-light;
    }
    &:before {
        width: 16px;
        margin-right: 12px;
    }
    &.short {
        &:after {
            width: 69px;
        }
    }
    &.long {
        &:after {
            width: 144px;
        }
    }
}
.filter-checkbox {
    @apply flex p-8 text-dark font-mon hover:bg-light transition-colors cursor-pointer rounded-sm;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 500;
    &:before {
        @apply block rounded-sm transition-colors border-gray;
        content: "";
        height: 16px;
        border: 1px solid;
        width: 16px;
        margin-right: 12px;
        flex: none;
    }
    &:not(.checked):hover {
        &:before {
            @apply border-dark;
        }
    }
    &.checked {
        &:before {
            @apply bg-green border-green;
        }
    }
}
</style>

<template>
    <div class="mb-40">
        <p class="text-h5 mb-24 font-bold" v-html="title"></p>
        <template v-if="loading">
            <div class="filter-loading short"></div>
            <div class="filter-loading long"></div>
        </template>
        <div v-else-if="success" class="-my-8 -ml-8">
            <div class="filter-checkbox" v-for="filter in results" :key="filter.slug" :class="{ checked: localValue.includes(filter[property]) }" @click="onValueChanged(filter[property])">
                {{ filter.name }}
            </div>
        </div>
        <template v-else></template>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            required: true,
            type: String
        },
        property: {
            required: false,
            type: String,
            default: "id"
        },
        endpoint: {
            required: true,
            type: String
        },
        value: {
            required: true,
            type: Array
        }
    },

    data: () => ({
        results: [],
        localValue: [],
        loading: false,
        success: false
    }),

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;
            this.success = false;
            axios
                .get(this.endpoint)
                .then(response => this.handleFetch(response.data))
                .catch(error => this.handleError(error))
                .finally(() => (this.loading = false));
        },
        handleFetch(data) {
            this.results = data;
            this.success = true;
        },
        handleError(e) {
            console.error(e);
        },
        onValueChanged(property) {
            this.localValue.includes(property) ? this.localValue.splice(this.localValue.indexOf(property), 1) : this.localValue.push(property);
            this.$emit("input", this.localValue);
        }
    },

    watch: {
        value: {
            immediate: true,
            handler: function(val) {
                this.localValue = val;
            }
        }
    }
};
</script>
